import { combineEpics } from "redux-observable";
import { epicDoghouseExchangeFreeTreats } from "./epics/epicDoghouseExchangeFreeTreats";
import { epicDoghouseGiveRequest } from "./epics/epicDoghouseGiveRequest";
import { epicDoghouseGiveTreat } from "./epics/epicDoghouseGiveTreat";
import { epicDoghouseNotEnoughTreat } from "./epics/epicDoghouseNotEnoughTreat";
import { epicDoghouseRewardReceived } from "./epics/epicDoghouseRewardReceived";
export var epicDoghouse = combineEpics(epicDoghouseGiveTreat, epicDoghouseGiveRequest, epicDoghouseNotEnoughTreat, epicDoghouseRewardReceived, epicDoghouseExchangeFreeTreats);



//////////////////
// WEBPACK FOOTER
// ./src/features/doghouse/epicDoghouse.ts
// module id = 1834
// module chunks = 3